<template lang="html">
  <div class="flex w-full">
    <transition name="in--left">
      <button
        v-if="!['creates', 'details', 'verifies'].includes(step)"
        class="hover:text-primary mr-auto focus:outline-none rounded"
        type="btn"
        aria-label="navigate back"
        @click="back"
      >
        <i
          class="fas fa-arrow-left bg-gray-300 rounded-full flex items-center text-lg justify-center w-8 h-8"
        ></i>
      </button>
    </transition>
    <transition name="in--up">
      <div v-if="error" class="flex items-center justify-center w-full px-4">
        <h3 class="text-red-500 text-sm">{{ errorMessage }}</h3>
      </div>
    </transition>
    <base-button
      :class="`h-12 flex flex-none ${disabled ? 'opacity-50' : ''}`"
      type="primary ml-auto"
      aria-label="navigate next"
      @click="next"
    >
      {{ loading ? 'Loading' : next_or_agree }}
      <i v-if="loading" class="fa fa-spinner fa-spin ml-2"></i>
      <transition name="in--right">
        <i v-if="!(loading || false)" class="fas fa-arrow-right text-lg ml-2"></i>
      </transition>
    </base-button>
  </div>
</template>

<script>
export default {
  name: 'Navigate',
  props: ['back', 'disabled', 'error', 'loading', 'next', 'step', 'verifying'],
  computed: {
    errorMessage() {
      if (!this.error) {
        return ''
      }

      const message = this.error.message || this.error
      console.log(message)

      if (message.includes("is not a valid 'AWSPhone'")) {
        return 'At least one of the phone numbers is not valid.'
      }

      if (message.includes('Invalid session for the user')) {
        return 'Your code may have expired after 3 minutes, or you may have entered an old code. Please check that this is the most recent code you received.'
      }

      if (message.includes('Routing number must be 9 characters.')) {
        return 'Routing number must be 9 characters.'
      }

      if (message.includes('Account number must be 4 characters or more')) {
        return 'Account number must be at least 4 characters.'
      }

      if (message.includes('routingNumber')) {
        return 'Please check that you entered the correct routing number.'
      }

      if (message.includes('routingNumber')) {
        return 'Please check that you entered the correct account number.'
      }

      if (message.includes("is not a valid 'AWSEmail'")) {
        return 'Please check that you entered a valid personal email address.'
      }

      if (message.includes('Invalid amount') || message.includes('Wrong amount(s)')) {
        return 'At least one of the micro deposit amounts is incorrect.'
      }

      return message
    },
    next_or_agree() {
      return this.step === ('links' && !this.$store.state.exited) ? 'Agree' : 'Next'
    }
  }
}
</script>
